/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Share_LabelInputs */

const cs_automation_share_label = /** @type {(inputs: Automation_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označení sdílení`)
};

const en_automation_share_label = /** @type {(inputs: Automation_Share_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share label`)
};

/**
* | output |
* | --- |
* | "Share label" |
*
* @param {Automation_Share_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_share_label = /** @type {((inputs?: Automation_Share_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Share_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_share_label(inputs)
	return cs_automation_share_label(inputs)
});